import { useIntl } from 'react-intl';
import { COMMON } from '../../../../../constants/strings';

const useJoinFormTitles = () => {
  const { formatMessage } = useIntl();

  const title = formatMessage({ id: 'paperwork.dob.title' });
  const descriptionText = formatMessage({ id: 'paperwork.dob.description' });
  const confirmButtonText = formatMessage({ id: 'paperwork.dob.confirm' });
  const agreeWithTermsAndPolicyText = ({ terms, policy }) =>
    formatMessage(
      { id: 'paperwork.dob.agreeWithTermsAndPolicy' },
      { terms, policy },
    );
  const termOfUseText = formatMessage(COMMON.termOfUse);
  const privacyText = formatMessage(COMMON.privacy);

  return {
    title,
    descriptionText,
    confirmButtonText,
    agreeWithTermsAndPolicyText,
    termOfUseText,
    privacyText,
  };
};

export default useJoinFormTitles;



// WEBPACK FOOTER //
// ./src/components/Paperwork/components/JoinForm/hooks/useJoinFormTitles.js